// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"ProfileDropdown_dropdown__oy3mr","option":"ProfileDropdown_option__DlHT3","separator":"ProfileDropdown_separator__X3QYB","red":"ProfileDropdown_red__hH3P0"};